var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M422.604 66.783h44.698v24.434c-238.012 22.479-424.635 222.412-424.635 465.305 0 257.917 210.393 467.478 469.333 467.478s469.333-209.561 469.333-467.478c0-242.893-186.623-442.826-424.635-465.305v-24.434h44.698v-66.783h-178.794v66.783zM807.692 114.696l103.149 102.739 44.826-44.652-103.145-102.739-44.83 44.652zM512.001 133.565c234.784 0 424.636 189.1 424.636 422.956s-189.851 422.96-424.636 422.96c-234.784 0-424.635-189.104-424.635-422.96s189.85-422.956 424.635-422.956zM267.588 325.321c-3.422 8.393-1.398 18.014 5.12 24.332l196.167 195.391c-1.024 3.742-1.552 7.6-1.572 11.478 0 24.589 20.012 44.522 44.698 44.522 3.906-0.002 7.795-0.514 11.568-1.521l39.678 39.521c5.606 5.815 13.93 8.158 21.762 6.124s13.949-8.125 15.99-15.927c2.042-7.801-0.31-16.092-6.148-21.676l-39.723-39.565c1.024-3.742 1.552-7.601 1.572-11.478 0-24.589-20.012-44.522-44.698-44.522-3.906 0.002-7.795 0.513-11.568 1.521l-196.122-195.348c-4.208-4.308-9.986-6.739-16.020-6.739-9.094 0.002-17.28 5.493-20.703 13.885z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.1d6c41e43cccd90385dee2886d06166e.svg";
export { ForwardRef as ReactComponent };